<div class="frame-parent">
  <div class="frame-wrapper">
    <div class="frame-title" translate>
      <ng-content></ng-content>
    </div>
  </div>
</div>
